import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import cx from 'classnames';
import { decorators, DataRow, getPaginator } from '@orange-marmalade/paginate-this';

// ducks
import { paginateThis } from '../../ducks/PropertySearch';

// components
import LoadError from '../../components/load-error/load-error';

// containers
import PropertyResult from './PropertyResult';
import PropertyResultsMap from './PropertyResultsMap';
import PropertyResultsTable from './PropertyResultsTable';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

class PropertySearchResults extends PureComponent {
  constructor(props) {
    super(props);
    this.onMarkerClick = this.onMarkerClick.bind(this);
  }

  render() {
    const { loadError, listId, ids, className, view, isLoading, propertyClass, reload } =
      this.props;

    return (
      <Container
        className={cx(className, BS.flex1, BS.positionRelative, {
          [BS.mb3]: view === 'map'
        })}
      >
        {view === 'map' && !loadError && (
          <PropertyResultsMap
            style={{
              flex: 1,
              position: 'relative',
              minHeight: 300,
              height: '100%'
            }}
            listId={listId}
            ids={ids}
            onMarkerClick={this.onMarkerClick}
            propertyClass={propertyClass}
          />
        )}
        {loadError && !isLoading && (
          <LoadError error={loadError} retry={() => reload()} />
        )}
        {view === 'thumb' && (
          <Row className={cx(styles.searchResults, BS.justifyContentStart, BS.mbn3)}>
            {ids.map((id, i) => {
              return (
                <Col
                  xs={12}
                  md={6}
                  className={cx(BS.mb3, styles.searchResultWrap)}
                  key={i}
                >
                  <DataRow itemId={id} component={PropertyResult} index={i} />
                </Col>
              );
            })}
            {ids.length === 0 && !isLoading && !loadError && (
              <Col xs={12} className={`${BS.mb3} ${BS.textCenter}`}>
                No Results
              </Col>
            )}
          </Row>
        )}
        {view === 'compare' && (
          <PropertyResultsTable listId={listId} ids={ids} propertyClass={propertyClass} />
        )}
        {isLoading && <div className={BS.loadingMask}>LOADING</div>}
      </Container>
    );
  }

  onMarkerClick(data) {}
}

export default decorators.tabulateLean(
  connect(
    (state, props) => {
      const paginator = getPaginator(props.listId, state),
        view = paginator.getIn(['filters', 'view']),
        loadError = paginator.get('loadError');

      return {
        view: props.view || view || 'thumb',
        loadError
      };
    },
    (dispatch, { reload }) => {
      return {
        reload: reload || paginateThis.pageActions.reload
      };
    }
  )(PropertySearchResults)
);



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertySearchResults.js